import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import RadioButton from 'LuxKit/Radio/RadioButton'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import useBedbankPackageViews from 'hooks/useBedbankPackageViews'
import React, { ComponentProps, useCallback, useMemo } from 'react'

interface Props extends Pick<ComponentProps<typeof DropdownList>, 'anchorRef' | 'triggerRef' | 'open' | 'onClose'> {
  selectedBedbankRoomId?: string;
  withFlights?: boolean;
  offer: App.BedbankOffer;
}

function CalendarRoomDropdown(props: Props) {
  const {
    anchorRef,
    triggerRef,
    open,
    onClose,
    offer,
    selectedBedbankRoomId,
  } = props
  const [packageViews] = useBedbankPackageViews(offer)

  const dispatch = useOfferPageDispatch()

  const onItemClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    const id = e.currentTarget.dataset.roomid
    const option = packageViews.find(pkg => pkg.package.roomId === id)
    dispatch({ type: OfferPageActions.setBedbankRoomId, bedbankRoomId: option?.package.roomId })
    onClose?.(e, 'internal-click')
  }, [dispatch, onClose, packageViews])

  const availableOptions = useMemo(() => packageViews.filter(pkg => pkg.available), [packageViews])
  return (
    <DropdownList
      size="M"
      anchorRef={anchorRef}
      triggerRef={triggerRef}
      open={open}
      title="Rooms"
      onClose={onClose}
    >
      <ClickableListItem
        title="View availability for all rooms"
        selected={!selectedBedbankRoomId}
        onClick={onItemClick}
        startIcon={<RadioButton checked={!selectedBedbankRoomId} />}
      />
      {availableOptions.map(option => <ClickableListItem
        key={option.package.roomId}
        title={option.package.name}
        disabled={!option.available}
        data-roomid={option.package.roomId}
        selected={selectedBedbankRoomId === option.package.roomId}
        onClick={onItemClick}
        startIcon={<RadioButton checked={selectedBedbankRoomId == option.package.roomId} />}
      />)}
    </DropdownList>
  )
}

export default withOfferPageAndReduxState((state) => {
  return {
    room: state.room,
    offer: state.bedbankOffer,
    withFlights: state.flights,
    selectedBedbankRoomId: state.selectedBedbankRoomId,
  }
}, CalendarRoomDropdown)
